module.exports = __webpack_public_path__ + "media/images/externalLink-987d6fa75dffc03197e1e713a660136c.svg";